import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { Utils } from 'src/app/pages/core/utils/Utils';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit {
  @Output() nextStep: EventEmitter<number> = new EventEmitter();
  @Output() openSelectSrcCoin: EventEmitter<boolean> = new EventEmitter();
  @Output() openSelectDestCoin: EventEmitter<boolean> = new EventEmitter();
  @Output() data: EventEmitter<{}> = new EventEmitter();
  @Input() srcCoinSelectorOpened: boolean;
  @Input() destCoinSelectorOpened: boolean;
  @Input() recoveryData;
  timeReplay: FormControl = new FormControl(0, [
    Validators.min(0),
    Validators.max(12),
    Validators.required,
  ]);
  amount: FormControl = new FormControl(null);
  previousValue: number;
  period: string;
  availableCoins: string[] = [];
  fromTicker: string = 'USDT';
  toTicker: string = 'BTC';
  frequencyButtons = ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY'];
  selectFrequency: string = 'DAILY';
  checkIsStable: boolean = false;
  balance: number = 0;
  constructor(public cryptoService: CryptoService, private authService: AuthService) {}

  ngOnInit(): void {
    this.setDefaultHour();
    this.checkCoinStable();
    this.availableCoins.push('ARS', 'USD');
    this.cryptoService.availableSwapCoins.subscribe((coins) => {
      coins.map((coin) => {
        this.availableCoins.push(coin);
      });
    });
    this.setBalance();
    this.setRecoveryData();
  }

  changeHour(number: number) {
    let newHour = this.timeReplay.value + number;
    if (newHour <= 12 && newHour > 0) this.timeReplay.setValue(this.timeReplay.value + number);
  }

  checkValidHour() {
    if (this.timeReplay.value && this.timeReplay.value > 12) {
      this.timeReplay.setValue(this.previousValue);
    } else {
      if (this.timeReplay.value <= 0) {
        this.timeReplay.setValue('');
      } else {
        this.previousValue = this.timeReplay.value;
      }
    }
  }

  setDefaultHour() {
    const currentDate = new Date();
    let hours = currentDate.getHours();
    let period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours + 1 : 1;
    if (hours === 12) {
      period === 'AM' ? (period = 'PM') : (period = 'AM');
    }
    this.period = period;
    this.timeReplay.setValue(hours);
  }

  restrictDecimal(event) {
    const decimalKey = 110;
    if (event.keyCode === decimalKey || (event.shiftKey && event.keyCode === decimalKey)) {
      event.preventDefault();
    }
  }

  changePeriod(selectPeriod: string) {
    this.period = selectPeriod;
  }

  changeStep() {
    this.sendData();
    this.nextStep.emit(2);
  }

  selectCoin(coin: string) {
    if (this.srcCoinSelectorOpened) {
      if (coin !== this.toTicker) {
        this.fromTicker = coin;
        this.srcCoinSelectorOpened = false;
      } else {
        this.switchCoins();
      }
      this.checkCoinStable();
      this.setBalance();
      if (
        !this.cryptoService.getValidSwapPair(coin, this.toTicker) &&
        this.toTicker !== 'ARS' &&
        this.toTicker !== 'USD' &&
        coin !== 'ARS' &&
        coin !== 'USD'
      ) {
        this.toTicker = 'USDT';
      }
    } else {
      this.toTicker = coin;
      this.destCoinSelectorOpened = false;
    }
  }

  switchCoins() {
    let auxCoin = this.fromTicker;
    this.fromTicker = this.toTicker;
    this.toTicker = auxCoin;
    this.setBalance();
  }

  changeFrecuency(frequency: string) {
    this.selectFrequency = frequency;
  }

  sendData() {
    let time = this.timeReplay.value;
    if (this.period === 'PM' && time !== 12) {
      time = time + 12;
      if (time === 24) time = 0;
    } else {
      if (time === 12 && this.period === 'AM') time = 0;
    }
    let data = {
      frequency: this.selectFrequency,
      runHour: time,
      fromTicker: this.fromTicker,
      toTicker: this.toTicker,
      amount: this.amount.value.replace(',', '.'),
    };
    this.data.emit(data);
  }

  checkCoinStable() {
    if (this.fromTicker !== 'ARS' && this.fromTicker !== 'USD')
      this.checkIsStable = this.cryptoService.isStableCoin(this.fromTicker);
    else this.checkIsStable = true;
  }

  setBalance() {
    if (this.fromTicker === 'ARS' || this.fromTicker === 'USD')
      this.balance = Utils.roundDown(this.authService.loggedUser.balance.fiat[this.fromTicker]);
    else {
      if (this.cryptoService.isStableCoin(this.fromTicker))
        this.balance = Utils.roundDownForSpecificDecimal(
          this.authService.loggedUser.balance.crypto[this.fromTicker]?.amount,
          3,
        );
      else
        this.balance = Utils.roundDownForOperation(
          this.authService.loggedUser.balance.crypto[this.fromTicker]?.amount,
        );
    }
    if (!this.balance) this.balance = 0;
    this.amount.setValidators([
      this.minValueValidator,
      Validators.required,
      Validators.max(this.balance),
    ]);
    this.amount.updateValueAndValidity();
  }

  minValueValidator(control: FormControl) {
    const value = parseFloat(control.value);
    if (isNaN(value) || value <= 0) {
      return { minValue: true };
    }
    return null;
  }

  setRecoveryData() {
    if (this.recoveryData) {
      let time = this.recoveryData.runHour;
      if (time > 12) {
        time = time - 12;
        this.period = 'PM';
      } else {
        if (time === 0) {
          time = 12;
        }
        this.period = 'AM';
      }
      this.timeReplay.setValue(time);
      this.amount.setValue(this.recoveryData.amount.replace('.', ','));
      this.selectFrequency = this.recoveryData.frequency;
      this.fromTicker = this.recoveryData.fromTicker;
      this.toTicker = this.recoveryData.toTicker;
      this.setBalance();
    }
  }
}
